import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "c-item-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemListPanel = _resolveComponent("ItemListPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "c-item-list__panel"
      }, [
        _createVNode(_component_ItemListPanel, {
          id: item.premium.id,
          "img-path": item.premium.premiumimage_set[0].image_url,
          name: item.premium.name,
          point: item.point_required,
          "discount-rate": item.discount_rate,
          "is-favorite": item.premium.is_featured,
          stock: item.quantity,
          "stock-control": item.is_quantity_control,
          color: _ctx.getColor(item),
          status: _ctx.status(item),
          "add-to-browser-history": _ctx.addToBrowserHistory
        }, null, 8, ["id", "img-path", "name", "point", "discount-rate", "is-favorite", "stock", "stock-control", "color", "status", "add-to-browser-history"])
      ]))
    }), 128))
  ]))
}